module.exports = __webpack_public_path__ + "img/master.4d9b4de0.png";